import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../api/axios';

function CompaniesList() {
  const [params] = useSearchParams();
  const category = params.get('category');
  const location = params.get('location');
  const collection = params.get('collection');

  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');
    // TODO: replace '/companies' with your real backend endpoint
    api
      .get('/companies', { params: { category, location, collection } })
      .then((res) => setCompanies(res.data?.data || res.data || []))
      .catch(() => setError('Could not load companies.'))
      .finally(() => setLoading(false));
  }, [category, location, collection]);

  const title = category
    ? `Companies in ${category.replace(/-/g, ' ')}`
    : location
    ? `Companies in ${location.replace(/-/g, ' ')}`
    : collection
    ? `${collection} companies`
    : 'All companies';

  return (
    <div className='max-w-7xl mx-auto px-4 md:px-8 py-8'>
      <h1 className='text-2xl font-bold text-[#1E1033] capitalize mb-6'>{title}</h1>

      {loading && <p className='text-gray-500'>Loading...</p>}
      {error && <p className='text-red-500'>{error}</p>}
      {!loading && !error && companies.length === 0 && (
        <p className='text-gray-500'>No companies found.</p>
      )}

      <div className='grid sm:grid-cols-2 lg:grid-cols-3 gap-4'>
        {companies.map((c) => (
          <Link
            key={c.id}
            to={`/company/${c.slug}`}
            className='bg-white border border-gray-100 rounded-xl p-4 shadow-sm hover:shadow-md transition'
          >
            <p className='font-semibold text-[#1E1033]'>{c.company_name || c.name}</p>
            <p className='text-sm text-gray-500'>{c.industry} {c.city && `• ${c.city}`}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default CompaniesList;